import React from 'react';
export default function Spinner() {
    return (React.createElement("div", { className: 'cio-plp-loading' },
        React.createElement("div", { className: 'cio-spinner', "data-testid": 'cio-spinner' },
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null))));
}
